module.exports = __webpack_public_path__ + "img/design proposal_demo-07.98b050ef.jpg";